module.exports = __webpack_public_path__ + "img/notifications.868231c7.svg";